import React, { useState } from "react";

// Make sure the path matches your project structure

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav>
      <a className="nav-logo" href="#">
        <img src="/logo.png" alt="Knights of the Ping Pong Table logo" />
        <div>
          <div className="nav-name">Knights</div>
          <div className="nav-num">FTC Team #19938</div>
        </div>
      </a>

      {/* Logic to toggle the menu class based on state */}
      <div className={`nav-links ${isOpen ? "active" : ""}`} id="nav-links">
        <a href="#about">About</a>
        <a href="#team">Team</a>
        <a href="#sponsors">Sponsors</a>
        <a href="#contact">Contact</a>
      </div>

      <button
        className="nav-toggle"
        id="nav-toggle"
        aria-label="Toggle menu"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>
  );
};

export default Navbar;
